import script from "./buyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./buyDetail.vue?vue&type=script&setup=true&lang=js"

import "./buyDetail.vue?vue&type=style&index=0&id=466770ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466770ab"]])

export default __exports__